import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=d5349910&scoped=true&"
import script from "./home-footer.vue?vue&type=script&lang=js&"
export * from "./home-footer.vue?vue&type=script&lang=js&"
import style0 from "./home-footer.vue?vue&type=style&index=0&id=d5349910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5349910",
  null
  
)

export default component.exports